import { useCallback, useState } from "react";

export function useWizard({ stepCount, isStepValid = () => true }) {
  const [currentStep, setCurrentStep] = useState(0);

  const canGoToStep = useCallback(
    (index) => {
      if (index < 0 || index >= stepCount) return false;
      if (index <= currentStep) return true;
      for (let i = currentStep; i < index; i += 1) {
        if (!isStepValid(i)) return false;
      }
      return true;
    },
    [currentStep, isStepValid, stepCount],
  );

  const goToStep = useCallback(
    (index) => {
      if (canGoToStep(index)) setCurrentStep(index);
    },
    [canGoToStep],
  );

  const goNext = useCallback(() => {
    goToStep(currentStep + 1);
  }, [currentStep, goToStep]);

  const goBack = useCallback(() => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  }, [currentStep]);

  return {
    currentStep,
    isFirstStep: currentStep === 0,
    isLastStep: currentStep === stepCount - 1,
    canGoToStep,
    goToStep,
    goNext,
    goBack,
  };
}
